module.exports = __webpack_public_path__ + "img/MobileImage7_en.7194ceea.png";